import {Applicant} from './applicant.model';

export class CarMoneyApplicationRequest {
  public AmountToBorrow: string;
  public VehicleType: string;
  public CreditScore: number;
  public Applicants: Array<Applicant> = [];
}
